'use strict';

module.exports = require('./dist/zoomus-websdk.umd.min');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zoomus/websdk/index.js
// module id = 992
// module chunks = 10 11